(function(){
     'use strict';

     angular
        .module('appback')
        .factory('AnalisisService', AnalisisService);

    AnalisisService.$inject = ['$http'];

    function AnalisisService($http){

        var service= {
           getHistAnalisisCentro:getHistAnalisisCentro,
           getAnaliticaByMuestraId:getAnaliticaByMuestraId,
           guardarPeticion:guardarPeticion,
           getAnaliticasByMuestra:getAnaliticasByMuestra,
           getAnaliticasCategoria:getAnaliticasCategoria,
           getReglas:getReglas,
           getMuestaAnimalYMuestras:getMuestaAnimalYMuestras,

        };

        return service;
 		function getHistAnalisisCentro(filtros,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/peticion/gethistanalisiscentro', { params : { lang_id:lang_id,filtros : filtros }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        

        function getMuestaAnimalYMuestras(muestra_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/peticion/getmuestraanimalymuestras', { params : { lang_id:lang_id, muestra_id : muestra_id }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        function getAnaliticasCategoria(carrito,animal,categoria,buscador,centro_id,muestraSeleccionada,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/peticion/getanaliticascategoria', { params : { muestra:(muestraSeleccionada.id ? muestraSeleccionada.id : ''), carrito:JSON.stringify(carrito),animal_id:animal.id,centro_id:centro_id,lang_id:lang_id,categoria : JSON.stringify(categoria),buscador:buscador }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        function getReglas(carrito,fields,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/peticion/getreglas', { params : { centro:fields.centro_id,carrito : JSON.stringify(carrito) }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        function getAnaliticasByMuestra(muestra_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/peticion/getanaliticasbymuestra', { params : { lang_id:lang_id, muestra_id : muestra_id }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        

        function guardarPeticion(carrito,fields,muestrasSeleccionadas,animal_id,alt_muestra_id,muestrasEstados,callback){
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
               fields:JSON.stringify(fields),
               carrito:JSON.stringify(carrito),
               muestrasSeleccionadas:JSON.stringify(muestrasSeleccionadas),
               muestrasEstados:JSON.stringify(muestrasEstados),
               animal_id:animal_id,
               alt_muestra_id:alt_muestra_id,
               lang_id:lang_id
            });
            $http.post('/backend/peticion/guardarpeticion', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }

        function getAnaliticaByMuestraId(muestra_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/peticion/getmuestrabyid', { params : { muestra_id : muestra_id, lang_id:lang_id }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

    }
})();